import { Nav, Avatar, Dropdown, Layout, Toast } from '@douyinfe/semi-ui';
import { usePrefixCls } from '../../../../hook/useConfig';
import ColorMode from './colorMode';
import LocaleMode from './localeMode';
import useStore from '../../../../store';
import { useGo } from '../../../../hook/useGo';
import useUserStore from '../../../../store/user';
import { IconExit, IconArticle } from '@douyinfe/semi-icons';
import GlobalSetting from './globalSetting';
import './header.scss';
import { DropDownMenuItem } from '@douyinfe/semi-ui/lib/es/dropdown';
import useSettingsStore from '@/store/settings';
import HeaderNav from './headNav';
import { CacheEnum } from '@/enum/cache';
import CountryMode from './countryMode';
import AsnGrabberEntry from './AsnGrabberEntry';
import BrowserExtensionEntry from './BrowserExtensionEntry';
import ToolboxEntry from './ToolboxEntry';
import ToolboxPanel from '@/components/Toolbox/ToolboxPanel';

const { Header } = Layout;

const HeaderIndex = () => {
  const prefixCls = usePrefixCls('layout-header');
  const { platformSetting } = useSettingsStore();
  const { userInfo } = useUserStore();
  const { setToken } = useStore();
  const { go } = useGo();

  function handleExit() {
    setToken('');
    localStorage.removeItem('user-info');
    localStorage.removeItem(CacheEnum.userCountry);
    localStorage.removeItem(CacheEnum.userId);
    localStorage.removeItem(CacheEnum.colorMode);
    sessionStorage.removeItem(CacheEnum.tabs);
    useStore.setState({ tabList: [] });
    Toast.success('退出成功');
    go({ path: '/login' });
  }

  const menuItems: DropDownMenuItem[] = [
    {
      node: 'item',
      name: '详情',
      icon: <IconArticle />,
    },
    {
      node: 'item',
      name: '退出',
      icon: <IconExit />,
      type: 'danger',
      onClick: handleExit,
    },
  ];
  return (
    <Header className={prefixCls}>
      <Nav
        style={{
          width: '100%',
        }}
        mode={'horizontal'}
        header={platformSetting.showBreadcrumb && <HeaderNav></HeaderNav>}
        footer={
          <>
            <ToolboxEntry />
            <AsnGrabberEntry />
            <BrowserExtensionEntry />
            {/* <ColorMode /> */}
            {/* <GlobalSetting></GlobalSetting> */}
            <CountryMode />
            <LocaleMode />
            <Dropdown
              position='bottom'
              style={{
                width: '90px',
              }}
              menu={menuItems}
            >
              <Avatar size='small' style={{ margin: 4, background: '#5F9CFF' }}>
                {userInfo?.username?.slice(0, 2)}
              </Avatar>
              <span>{userInfo?.username}</span>
            </Dropdown>
          </>
        }
      ></Nav>
      <ToolboxPanel />
    </Header>
  );
};

export default HeaderIndex;
